var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 36,
    viewBox: "0 0 20 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00A09A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16.154 0H3.846C1.731 0 0 1.76 0 3.913v28.174C0 34.239 1.73 36 3.846 36h12.308C18.269 36 20 34.24 20 32.087V3.913C20 1.761 18.27 0 16.154 0zm2.308 32.087c0 1.291-1.039 2.348-2.308 2.348H3.846c-1.27 0-2.308-1.057-2.308-2.348v-3.913h16.924v3.913zm0-5.478H1.538V6.26h16.924v20.348zm0-21.913H1.538v-.783c0-1.291 1.039-2.348 2.308-2.348h12.308c1.27 0 2.308 1.057 2.308 2.348v.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10 33.652c1.27 0 2.308-1.056 2.308-2.348 0-1.291-1.039-2.347-2.308-2.347-1.27 0-2.308 1.056-2.308 2.347 0 1.292 1.039 2.348 2.308 2.348zm0-3.13c.423 0 .77.352.77.782 0 .43-.347.783-.77.783a.778.778 0 0 1-.77-.783c0-.43.347-.782.77-.782z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.385 2.348h-.77a.778.778 0 0 0-.769.782c0 .43.346.783.77.783h.769c.423 0 .769-.352.769-.783a.778.778 0 0 0-.77-.782z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmartphone);
export default __webpack_public_path__ + "static/media/icon-smartphone.faf0bd1f0c91ff97781fe603d15459f2.svg";
export { ForwardRef as ReactComponent };